import { MarketoService } from "@/types/services/marketo";
import marketoCookie from "@/util/marketo-cookie";

export const marketoService: MarketoService = {
  getCookie: () => {
    return marketoCookie();
  },
};
